import { getUserInfoAPI } from '@/api/user.js'
import {getUserInfo } from '@/api/user'
import router from '@/router'


// 用户模块
const userModule = {
  namespaced: true,
  state() {
    return {
      userInfo: {},
      users:{},
      token: localStorage.getItem('token') || ''
    }
  },
  mutations: {
    getUserInfo(state, user) {
      state.userInfo = user

      state.token = user.token
      localStorage.setItem('token', state.token)
    },
    getUser(state,users){
      state.users = users
      // localStorage.setItem('token', state.users)
    },
    changeuserinfo(state){
        state.userInfo = {}
        state.token = ''
        localStorage.setItem('token', '')
        router.push('/login')
    }
  },
  actions: {
    async asyncGetUserInfo({ dispatch,commit }, user) {
      const { data: res } = await getUserInfoAPI(user)
      if (res.code !== 200) {
        localStorage.removeItem('token')
        localStorage.removeItem('vuex')
        return { type: 'error', message: res.msg }
      } else {
        commit('getUserInfo', res.data)
        dispatch('asyncGetUser')
        return { type: 'success', message: '登录成功！' }
      }
    },
    async asyncGetUser({commit }, user) {
      const res2 = await getUserInfo()
      if(res2.data.code !== 200) {
        return { type: 'error', message: res2.msg }
      }else{
      commit('getUser', res2.data.data)
      }
    },
  },
  getters: {}
}
export default userModule
